var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select',{attrs:{"id":"my_select"},on:{"change":_vm.onSelectChange}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,domProps:{"value":option.id,"selected":option.id == _vm.preselectedId}},[_vm._v(" "+_vm._s(_vm.$t(option.isoCode3))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }